import { DateTime } from '%app/js/localized-luxon';
import {
    VISIBILITY_FOR_CASHIER,
    VISIBILITY_PUBLIC,
    VISIBILITY_TECHNICAL,
} from '%paysera_simple_event/js/event/component/Form/component/TicketTypes/config/constants';
import { canCreateOrder } from '%evp_ticket_frontend/js/react/service/currentBuyerPermissions';

function isWithinDateBounds(item) {
    const now = DateTime.fromMillis(Date.now()).toSeconds();
    return (item.date_starts === null || now >= item.date_starts)
        && (item.date_ends === null || now <= item.date_ends);
}

function isWithinAccessScope(item) {
    return (
        [VISIBILITY_PUBLIC, VISIBILITY_TECHNICAL].includes(item.visibility)
        || (canCreateOrder() && item.visibility === VISIBILITY_FOR_CASHIER)
    );
}

function isVisible(item) {
    return isWithinDateBounds(item) && isWithinAccessScope(item);
}

function isPriceTypeVisible(item) {
    return isVisible(item) && item.enabled;
}

function isTicketTypeVisible(item) {
    return isVisible(item);
}

function isPriceTypeHidden(item) {
    return item.ignore_price || !item.enabled;
}

export {
    isPriceTypeHidden,
    isPriceTypeVisible,
    isTicketTypeVisible,
};
